"use strict";

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var currentId = 0;
var components = {};

var track = exports.track = function track(component) {
  var id = currentId;
  components[id] = component;
  currentId += 1;
  return id;
};

var get = exports.get = function get(id) {
  return components[id];
};
var getAll = exports.getAll = function getAll() {
  return _extends({}, components);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/loadable-components/componentTracker.js
// module id = 16
// module chunks = 3